import WebsiteSplitter from './WebsiteSplitter';

export default WebsiteSplitter;
